import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { ConfigProvider, Table, Empty } from 'antd';
import moment from 'moment';
import {
  GetProjectTablesInvestmentDetails,
  ResetProjectTablesInvestmentDetails
} from '../../../redux/ProjectDetail/actions';
import { buildQueryString, defaultSpfParameters } from '../../../helpers/http/request';
import styles from './styles.module.scss';
import NumberFormat from 'react-number-format';

const InvestmentTable = (props) => {
  useEffect(() => {
    getInvestmentDetails();
  }, []);

  const getInvestmentDetails = (pagination) => {
    const payload = {
      projectId: props.projectId,
      queryString: buildQueryString({
        ...defaultSpfParameters,
        page: pagination?.current,
        pageSize: pagination?.pageSize
      })
    };
    props.GetProjectTablesInvestmentDetails(payload);
  };

  useEffect(() => {
    return () => {
      props.ResetProjectTablesInvestmentDetails();
    };
  }, []);

  const onPageChange = (pagination) => {
    getInvestmentDetails(pagination);
  };

  const investmentTableColumns = [
    {
      title: props.language.investorName,
      dataIndex: 'investorName',
      key: 'investorName'
    },
    {
      title: props.language.status,
      dataIndex: 'isQualified',
      key: 'isQualified',
      render: (isQualified) => {
        return <span>{isQualified ? props.language.licence : props.language.nonLicence}</span>;
      }
    },
    {
      title: props.language.shareCount,
      dataIndex: 'shareCount',
      key: 'shareCount',
      render: (shareCount) => {
        return (
          <NumberFormat
            value={shareCount}
            displayType={'text'}
            thousandSeparator="."
            prefix=""
            decimalSeparator=","
            decimalScale={2}
          />
        );
      }
    },
    {
      title: props.language.ownedPercentage,
      dataIndex: 'ownedPercentage',
      key: 'ownedPercentage',
      render: (ownedPercentage) => {
        return (
          <NumberFormat
            value={ownedPercentage}
            displayType={'text'}
            thousandSeparator="."
            prefix={'%'}
            decimalSeparator=","
            decimalScale={props.decimalScale.toString().length}
          />
        );
      }
    },
    {
      title: props.language.fundingAmount,
      dataIndex: 'fundingAmount',
      key: 'fundingAmount',
      render: (fundingAmount) => {
        return (
          <NumberFormat
            value={fundingAmount}
            displayType="text"
            thousandSeparator="."
            prefix="₺"
            decimalSeparator=","
            decimalScale={2}
          />
        );
      }
    },
    {
      title: props.language.orderDate,
      dataIndex: 'createDateTime',
      key: 'createDateTime',
      render: (orderDate) => {
        return <span>{moment.utc(orderDate).local().format('DD.MM.YYYY')}</span>;
      }
    },
    {
      title: props.language.investmentStatus,
      dataIndex: 'investmentStatus',
      key: 'investmentStatus',
      render: (investmentStatus) => {
        return <span>{props.investmentStatus[investmentStatus]}</span>;
      }
    },
    {
      title: props.language.lastStatusChangeDateTime,
      dataIndex: 'lastStatusChangeDateTime',
      key: 'lastStatusChangeDateTime',
      render: (lastStatusChangeDateTime) => {
        return (
          <span>
            {!!lastStatusChangeDateTime
              ? moment.utc(lastStatusChangeDateTime).local().format('DD.MM.YYYY')
              : null}
          </span>
        );
      }
    }
  ];

  return (
    <section>
      <Row>
        <Col sm={12}>
          <h3 className={styles.text}>{props.language.fundings}</h3>
        </Col>
      </Row>
      {!!props.projectDetail?.tablesInvestmentDetails?.response?.parameters &&
        !!props.projectDetail?.tablesInvestmentDetails?.response?.data && (
          <Row>
            <Col sm={12}>
              <ConfigProvider
                renderEmpty={() => <Empty description={<p>{props.language.emptyText}</p>} />}
              >
                <Table
                  scroll={{ x: 580 }}
                  pagination={props.projectDetail?.tablesInvestmentDetails?.response?.parameters}
                  columns={investmentTableColumns}
                  dataSource={props.projectDetail?.tablesInvestmentDetails?.response?.data}
                  locale={props.language.emptyText}
                  onChange={onPageChange}
                  rowKey={(record) => record.id}
                />
              </ConfigProvider>
            </Col>
          </Row>
        )}
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    language: state.language.dashboard.tables,
    investmentStatus: state.language.investmentStatus,
    projectDetail: state.projectDetail
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetProjectTablesInvestmentDetails: (payload) =>
      dispatch(GetProjectTablesInvestmentDetails(payload)),
    ResetProjectTablesInvestmentDetails: (payload) =>
      dispatch(ResetProjectTablesInvestmentDetails(payload))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvestmentTable);

